import React from "react";

import type { SxProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Row } from "@rui/Stack";

const Overlay = styled(Row)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[60],
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  "&:hover:not(.disabled)": {
    cursor: "pointer",
    "& .playback-overlay-button__button": {
      backgroundColor: theme.palette.transparent.white[40],
    },
  },
}));

const PlaybackOverlay = ({
  children,
  onClick,
  sx,
}: {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  sx?: SxProps;
}) => {
  const handleClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <Overlay
      variant="center"
      spacing={3}
      onClick={handleClick}
      className={onClick ? undefined : "disabled"}
      sx={sx}
    >
      {children}
    </Overlay>
  );
};

export default PlaybackOverlay;
